import styles from "./Sidebar.module.css";
import { NavLink } from "react-router-dom";
import { 
  MdDashboard, 
  MdBusiness, 
  MdPeople, 
  MdChat, 
  MdConfirmationNumber, 
  MdPhotoLibrary, 
  MdSettings, 
  MdHelp, 
  MdLogout 
} from "react-icons/md";


function Sidebar({ onLogout }) {
  
  return (
    
    <aside className={styles.sidebar}>
      <div>
        <img
          src={`${process.env.PUBLIC_URL}/iconGM.png`}
          alt="Логотип"
          className={styles.logo}
        />
        <nav className={styles.menu}>
          <NavLink className={styles.menuItem} to="/content/main">
            <MdDashboard size={22} />
            <span>Главная</span>
          </NavLink>

          <NavLink className={styles.menuItem} to="/content/company">
            <MdBusiness size={22} />
            <span>Компания</span>
          </NavLink>

          <NavLink className={styles.menuItem} to="/content/clients">
            <MdPeople size={22} />
            <span>Клиенты</span>
          </NavLink>

          <NavLink className={styles.menuItem} to="/content/chats">
            <MdChat size={22} />
            <span>Чаты</span>
          </NavLink>

          <NavLink className={styles.menuItem} to="/content/tickets">
            <MdConfirmationNumber size={22} />
            <span>Тикеты</span>
          </NavLink>

          <NavLink className={styles.menuItem} to="/content/banners">
            <MdPhotoLibrary size={22} />
            <span>Баннеры / Объявления</span>
          </NavLink>

          <NavLink className={styles.menuItem} to="/content/settings">
            <MdSettings size={22} />
            <span>Настройки</span>
          </NavLink>

          <NavLink className={styles.menuItem} to="/content/help">
            <MdHelp size={22} />
            <span>Помощь</span>
          </NavLink>
        </nav>
      </div>

      <button className={styles.logout} onClick={onLogout}>
        <MdLogout size={22} />
        <span>Выйти</span>
      </button>
    </aside>
  );
}

export default Sidebar;
